import React from "react";
import { Layout } from "layout";

function App() {
  return <Layout />;
}

export default App;
